import React from 'react';

import moment from 'moment';
import { Link } from 'react-router-dom';

import { formatCurrency } from '../../../../../../helpers/currencyMask';

export default function PaymentInfoLink({ paymentLineItem, loanId }) {
  const date = paymentLineItem._payment?.date;
  const { amount } = paymentLineItem;
  const source = paymentLineItem._payment?.source;
  const id = paymentLineItem._payment?.id;

  const link = `/loans/${loanId}/payments/${id}?tab=Payment`;

  return (
    <Link to={link} className="text-indigo-500 underline">
      Payment: {moment(date).format('M/D/YY')} ${formatCurrency(amount)} (
      {source})
    </Link>
  );
}
